import { render, staticRenderFns } from "./DemoSimpleTableBasic.vue?vue&type=template&id=4089ecb2"
import script from "./DemoSimpleTableBasic.vue?vue&type=script&lang=js"
export * from "./DemoSimpleTableBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports